var _defs, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stage_3:_Tribal_Alignment",
    "data-name": "Stage 3: Tribal Alignment",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1727",
    "data-name": "Rectangle 1727",
    width: 36.773,
    height: 37.36,
    fill: "#fff"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_682",
    "data-name": "Ellipse 682",
    cx: 25,
    cy: 25,
    rx: 25,
    ry: 25,
    fill: "#ee3d4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32055",
    "data-name": "Group 32055",
    transform: "translate(4.604 4.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32054",
    "data-name": "Group 32054",
    transform: "translate(2.113 2.146)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13521",
    "data-name": "Path 13521",
    d: "M30.214,0a4.352,4.352,0,1,1-4.392,4.352A4.371,4.371,0,0,1,30.214,0h0M18.389,2.068A4.352,4.352,0,1,1,14,6.42a4.371,4.371,0,0,1,4.392-4.352M6.563,0A4.352,4.352,0,1,1,2.172,4.352,4.371,4.371,0,0,1,6.563,0m3.963,26.71h-.77L9.165,34.8a.519.519,0,0,1-.52.479H4.485a.52.52,0,0,1-.521-.479L3.372,26.71A2.654,2.654,0,0,1,.778,24.14L0,12.741a2.528,2.528,0,0,1,2.494-2.566h8.032a2.606,2.606,0,0,1,2.164,1.156A3.881,3.881,0,0,0,10.5,14.815v11.4c0,.046.032.5.03.5m13.644-.5a2.659,2.659,0,0,1-2.594,2.574l-.591,8.093a.522.522,0,0,1-.521.479H16.308a.515.515,0,0,1-.52-.479l-.595-8.093A2.659,2.659,0,0,1,12.6,26.213l-.778-11.4a2.533,2.533,0,0,1,2.5-2.571h8.034a2.533,2.533,0,0,1,2.594,2.47v.1ZM36,24.145A2.654,2.654,0,0,1,33.4,26.716L32.81,34.81a.524.524,0,0,1-.521.479H28.136a.519.519,0,0,1-.52-.479l-.595-8.094h-.779a3.953,3.953,0,0,0,.036-.5v-11.4a3.892,3.892,0,0,0-2.195-3.485,2.606,2.606,0,0,1,2.163-1.154h7.932a2.532,2.532,0,0,1,2.594,2.466v.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage3);
export default __webpack_public_path__ + "static/media/stage3.29a563988872632bdf4c76337183c261.svg";
export { ForwardRef as ReactComponent };